import React from 'react'

import Image from 'next/image'

import { appStoreBadgeImage } from 'Assets/Images'

import { APP_LINK } from 'Constants/Ids'

import { StyledLink } from './styles'

function AppStoreLink() {
  return (
    <StyledLink
      href={APP_LINK.APP_STORE}
      rel="noopener noreferrer"
      target="_blank"
    >
      <Image alt="Download on the App Store" src={appStoreBadgeImage} />
    </StyledLink>
  )
}

export default AppStoreLink
